import { ReactTable } from "@funcional/react-table-ui";
import { IconButton, Title } from "@funcional/react-ui";
import { DropDownList } from "./DropDownList";
import { TextInput } from "./TextInput";
import { useFieldArray } from "react-hook-form";
import { Column, useTable } from "react-table";
import { useEffect, useMemo, useState } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { IDiscountRange } from "@refund/register-fixed-discount-rules/register/contracts";
import { v4 as uuid } from "uuid";
import { getWatchValueCached } from "../helpers";

interface RangeWithErrors extends IDiscountRange {
  errors?: any;
};
  
export const ExceptionsForm = ({
  control,
  register,
  errors,
  optionsData,
  readonly,
  watchValue,
}: any) => {
  //It's necessary to a find watch value in table component
  localStorage.setItem('watchValue', JSON.stringify(watchValue));
  const retailChainsOptions = optionsData?.retailChains;
  const closureTypesOptions = optionsData?.closureTypes;
  
  const { fields, append, remove } = useFieldArray({
    control,
    name: "exceptions",
  }); 
  const preparedData = fields?.map((exception, index) => ({ 
    ...exception,
    id: uuid(),
    errors: errors?.exceptions?.[index],
  }));
  
  const addOption = () => {
    const item = {
      id: uuid(),
      a: "",
      b: "",
      c: "",
    } as never;
    append([item]);
  };

  const deleteOption = (index: any, ) => {
    if (window.confirm("Tem certeza de que deseja excluir esta exceção?")) {
      remove(index);
      const serializedData = localStorage.getItem("financialReimbursementCachedData");
      const data = JSON.parse(serializedData ? serializedData : "");
      data.exceptions.splice(index, 1);
      localStorage.setItem("financialReimbursementCachedData", JSON.stringify(data));
    }
  };
    
  const columns: Column<RangeWithErrors>[] = useMemo(
      () =>
        [
          {
            Header: "Período",
            accessor: "closureType",
            Cell: ({
              row: {
                index,
                original: { errors, id },
              },
              value,
            }: any) => (
              <DropDownList 
              key={id}
              options = {closureTypesOptions} 
              item = "closureType" 
              readonly={readonly}
              control={control}
              errors={errors}
              defaultValue={(preparedData[index] as any)?.closureType ? (preparedData[index] as any)?.closureType : ""}
              register={register}
              index={index}/>
            ),
          },
          {
            Header: "Dia",
            accessor: "closingDay",
            Cell: ({
              row: {
                index,
                original: { errors, id },
              },
              value,
            }: any) => {
              const watchValueCached = getWatchValueCached();
              return (
                <TextInput 
                key={id}
                item = "closingDay" 
                readonly={readonly}
                control={control}
                defaultData={(preparedData[index] as any)?.closingDay ? preparedData[index] : {}}
                errors={errors}
                register={register}
                index={index}
                watchValue={watchValueCached.exceptions? watchValueCached.exceptions[index]: {}}/>
            )},
          },
          {
            Header: "Bandeira",
            accessor: "retailChainId",
            Cell: ({
              row: {
                index,
                original: { errors, id },
              },
              value,
            }: any) => (
              <DropDownList
              key={id} 
              options = {retailChainsOptions} 
              item = "retailChainId" 
              readonly={readonly}
              control={control}
              errors={errors}
              defaultValue={(preparedData[index] as any)?.retailChainId ? (preparedData[index] as any)?.retailChainId : ""}
              register={register}
              index={index}/>
            ),
          },
        ] as Column<RangeWithErrors>[],
      [register]
    );
    
    const tableInstance = useTable(
      { columns, data: preparedData as any},
      (hooks: any) => {
        hooks.visibleColumns.push((columns: any) => [
          ...columns,
          {
            id: "crud",
            Header: () => {
              if(!readonly) {
                return (
                  <IconButton
                    size="small"
                    title="Adicionar faixa"
                    onClick={addOption} 
                  >
                    <AddIcon />
                  </IconButton>
                );
              }
              return <></>;
            },
            Cell: ({
              row: { index }
            }: any) => {
              if (!readonly) {
                return (
                  <div className="flex">
                    <IconButton
                      size="small"
                      title="Excluir"
                      onClick={() => {
                        deleteOption(index);
                    }}>
                      <DeleteIcon />
                    </IconButton>
                  </div>
                )
              }
              return <></>;
            },
          },
        ]);
      }
    );
  
    return (
      <>
        <Title level={3}>Exceções</Title>
        <ReactTable compact footer tableInstance={tableInstance} />
      </>
    );
  };